"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  AutoComplete: {
    placeholder: '请输入',
    noData: '暂无搜索结果'
  },
  FileInput: {
    placeholder: '请选择文件',
    remove: '移除',
    choice: '选择'
  },
  Upload: {
    defaultError: '上传失败'
  },
  ImageUpload: {
    upload: '点击上传',
    uploadAgain: '点击重新上传'
  },
  Loading: {
    text: '正在加载'
  },
  Modal: {
    openText: '确 定',
    closeText: '取 消'
  },
  Select: {
    placeholder: '请选择',
    noData: '暂无搜索结果',
    noChoice: '暂无选项'
  },
  Mark: {
    texts: ['极差', '失望', '一般', '满意', '惊喜']
  },
  DatePicker: {
    monthText: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    daysText: ['一', '二', '三', '四', '五', '六', '日'],
    placeholder: '请选择时间',
    selectStartPlaceholder: '开始时间',
    selectEndPlaceholder: '结束时间',
    selectMonthText: '请选择月',
    selectYearText: '请选择年',
    week: '周'
  }
};
exports.default = _default;